import React from 'react';

import zolaLogo from '../../assets/images/rebrand/zola-logomark-marine.svg';

import styles from './MinimalHeader.module.less';

const MinimalHeader: React.FC = () => (
  <header className={styles.container}>
    <a href="/">
      <img src={zolaLogo} alt="Zola" className={styles.logo} />
    </a>
  </header>
);

export default MinimalHeader;
